<template>
  <ion-header>
    <ion-toolbar>
      <ion-title v-text="'AUTENTICACIÓN'"></ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content :fullscreen="true">
      <div class="fondo">
        <div class="ion-padding">
          <ion-label class="ion-text-center">
            <p>A TU CORREO SE A ENVIADO EL CÓDIGO ÚNICO DE ACCESO.</p>
          </ion-label>
          <h2 class="ion-text-center">INVERLUZ S.A.</h2>
        </div>
        <div class="ion-padding-horizontal ion-margin-horizontal ion-justify-content-center">
          <ion-row class="ion-text-center ion-justify-content-center">
            <ion-col size="6">
              <ion-input class="input-code" color="warning" maxlength="4" type="text" v-model="codigo" @keyup.enter="iniciarSesion();"></ion-input>
            </ion-col>
          </ion-row>
          
        </div>
        <div class="ion-padding ion-margin-top">
          <ion-label class="ion-text-center">
            <p>TIENES 5 MINUTOS PARA INGRESAR EL CODIGO.</p>
          </ion-label>
        </div>
        <div class="ion-padding-horizontal ion-margin-horizontal">
          <ion-row class="ion-text-center ion-justify-content-center">
            <ion-col size="8">
              <ion-button class="btn-ingresar" color="dark" shape="round" expand="block" @click="iniciarSesion();">
                <ion-icon name="log-in-outline"></ion-icon>
                <ion-label style="margin-left:10px;">INGRESAR</ion-label>
              </ion-button>

            </ion-col>
          </ion-row>
        </div>
      </div>
    </ion-content>

</template>

<script>
import { IonHeader, IonToolbar, IonTitle, IonContent, IonLabel, IonButton, modalController, isPlatform, toastController, 
          loadingController, IonIcon, IonCol, IonRow, IonInput } from '@ionic/vue';
import { defineComponent   } from 'vue';
import { addIcons          } from 'ionicons';
import { logInOutline      } from 'ionicons/icons';
import { PushNotifications } from '@capacitor/push-notifications';
import { Preferences       } from '@capacitor/preferences';
import axios      from 'axios';
import rutaBase   from '@/plugins/variables';

export default defineComponent({
  name: 'ValidaLogin',
  props: {
    rutProp           : String,
    claveProp         : String,
    inicioDirectoProp : Boolean,
    usuarioProp       : Object,
    tokenProp         : String,
    modal             : Object
  },
  components: {
    IonHeader, IonToolbar, IonTitle, IonContent, IonLabel, IonButton, IonIcon, IonCol, IonRow, IonInput
  },
  data() {
    return { 
      codigo        : '',
      validacion    : false,
      rut           : '',
      clave         : '',
      movil         : 0
    }
  },
  mounted() {
    console.log(this.inicioDirectoProp);
    console.log(this.usuarioProp);
    console.log(this.tokenProp);
    if((isPlatform('ios') || isPlatform('android') || isPlatform('mobile')) && !isPlatform('mobileweb') && !isPlatform('desktop')){
      this.movil = 1;
    }
    if(this.rutProp && this.claveProp) { 
      this.rut    = this.rutProp.toString();
      this.clave  = this.claveProp.toString();
    }
    if(this.inicioDirectoProp == true){
      this.muestraCargando();
      const modoOscuro  = this.usuarioProp.usr_modo_oscuro ? 1:0;
      this.registraDatosSesion(this.usuarioProp, this.tokenProp, modoOscuro);
    }
    addIcons({
      'log-in-outline'      : logInOutline
    });
  },
  methods:{
    async iniciarSesion(){
      if(this.rut && this.clave) {  
        this.muestraCargando();
        const dato  = new URLSearchParams();
        dato.append('rut'     , this.rut.toString());
        dato.append('clave'   , this.clave.toString());
        dato.append('ccodigo' , '1');
        dato.append('codigo'  , this.codigo.toString());
        dato.append('movil'   , this.movil.toString());
        axios.post(rutaBase+'/login/iniciarSesion', dato).then( resp => {
          if(resp.data.key == 1){
            const usuario     = resp.data.usuario;
            const modoOscuro  = usuario.usr_modo_oscuro ? 1:0;
            this.registraDatosSesion(usuario, resp.data.token, modoOscuro);
          }
          else if(resp.data.key == 3){
            this.muestraToast('CODIGO INCORRECTO.');
          }
          else if(resp.data.key == 2){
            this.muestraToast('CODIGO CADUCO.');
          }
          else if(resp.data.resp.key == 0){
            this.muestraToast('ERROR DE SISTEMA, AL VALIDAR DATOS.');
          }
        }).catch((error) =>{
          console.log(error)
          this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
        });
      }
    }, 

    async registraDatosSesion(usuario, token, modoOscuro){
      Preferences.set({
        key: 'rut',
        value: this.rut.toString()
      });
      Preferences.set({
        key: 'nombres',
        value: usuario.usr_nombres.toString()
      });
      Preferences.set({
        key: 'apellido_p',
        value: usuario.usr_apellido_p.toString()
      });
      Preferences.set({
        key: 'apellido_m',
        value: usuario.usr_apellido_m.toString()
      });
      Preferences.set({
        key: 'tipo_usuario',
        value: usuario.usr_tipo_usuario.toString()
      });
      Preferences.set({
        key: 'modo_oscuro',
        value: modoOscuro.toString()
      });
      Preferences.set({
        key: 'cambio_clave',
        value: usuario.usr_cambio_clave.toString()
      });
      Preferences.set({
        key: 'clave',
        value: this.clave.toString()
      });
      Preferences.set({
        key: 'token_auth',
        value: token.toString()
      });

      if(this.movil == 1){
        console.log('movil 1');
        this.registraTokenNoti(this.rut.toString());
      }
      else{
        console.log('movil 0');
        modalController.dismiss({validacion:true});
        location.reload();
      }
    },

    async registraTokenNoti(rut){
      // Register with Apple / Google to receive push via APNS/FCM
      await PushNotifications.register();

      await PushNotifications.createChannel({
        description   : 'Notificaciones de Sistema.',
        id            : 'canal_ayuda',
        name          : 'Canal Ayuda',
        sound         : 'noti_ayuda.wav',
        vibration     : true,
        lights        : true,
        lightColor    : '#33DDFF',
        importance    : 5,
        visibility    : 1
      }).then(()=>{
          console.log('CANAL 1 CREADO');
      }).catch(error =>{
          console.log('push channel error: '+error);
      });

      // On success, we should be able to receive notifications
      await PushNotifications.addListener('registration', token => {
          const dato  = new URLSearchParams();
          dato.append('rut'     , rut);
          dato.append('token'   , token.value);
          axios.post(rutaBase+'/login/registraToken', dato).then( resp => {
            //this.cargando = false;
            if(resp.data.key == 1){
              Preferences.set({
                key: 'token_noti',
                value: token.value
              });
              modalController.dismiss({validacion:true});
            }
            else{
              this.muestraToast('ERROR AL GUARDAR TOKEN, INTENTALO MAS TARDE.');
            }
          }).catch((error) =>{
            //this.cargando = false;
            //this.muestraToast('ERROR DE CONEXION AL GUARDAR TOKEN.');
            this.muestraToast('ERROR: '+error);
          });
          
        }
      );

      // Some issue with our setup and push will not work
      await PushNotifications.addListener('registrationError', error => {
          this.muestraToast('Error de registro token, '+JSON.stringify(error));
        }
      );

      // Show us the notification payload if the app is open on our device
      await PushNotifications.addListener('pushNotificationReceived', notification => {
          alert('Push received: ' + JSON.stringify(notification));
        }
      );

      // Method called when tapping on a notification
      await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
          this.muestraToast('Push action performed: ' + JSON.stringify(notification));
        }
      );
    },

    async muestraCargando(){
      const alertCargando = await loadingController
        .create({
          cssClass: 'my-custom-class',
          message: 'CARGANDO...',
          duration: 2500,
        });
      await alertCargando.present();
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 4000,
          cssClass: 'text-center'
        })
      return toast.present();
    }
  }
});
</script>

<style scoped>
.fondo{
  /* background-color: #d7d8da !important; */
  height: 100% !important;
  padding-top: 15%;
}

.btn-ingresar {
  height: 50px!important;
}

.input-code{
  background-color: white !important;
  border-radius: 50rem!important;
  font-size: 30px;
  margin: auto;
  padding-left: 0px!important;
  border: 1px solid black!important;
}

</style>